import React from 'react';
import { AccountRoute } from 'routes';
import { DashboardContainerLayout } from 'common/pages/LayoutPage';
import { useSelector } from 'react-redux';
import {
  needMfaEnabledSelector,
  tokenPayloadSelector,
} from 'state/auth/auth.selectors';
import { BusinessPartnerModuleMenu } from 'pages/BusinessPartnerManagement/BusinessPartnerModuleMenu';
import { Layout, Result, Spin } from 'antd';
import { Content } from 'common/StyledComponents';
import { BusinessPartnerManagementRouter } from 'pages/BusinessPartnerManagement/BusinessPartnerManagementRouter';
import { useQuery } from 'react-query';
import { QueryKey } from 'api/queryKey';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { PrivateRoute } from 'common/AuthRoute';
import { AccountManagementRouter } from 'pages/AccountManagement/AccountManagementRouter';
import { Switch } from 'react-router-dom';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useRouteMatch } from 'react-router';

export const AdminModule = () => {
  const tokenPayload = useSelector(tokenPayloadSelector)!;
  const needMfaEnabled = useSelector(needMfaEnabledSelector);
  const businessPartnerId = tokenPayload.partnerId!;
  const { url } = useRouteMatch();

  const { isLoading, isSuccess, data } = useQuery(
    [QueryKey.BusinessPartner, businessPartnerId],
    () => {
      if (!needMfaEnabled) {
        return BusinessPartnersAPI.fetchById(businessPartnerId);
      }
    }
  );

  const intlMessage = useFormatMessage();

  return (
    <DashboardContainerLayout menu={<BusinessPartnerModuleMenu />}>
      <Switch>
        <PrivateRoute path={AccountRoute} component={AccountManagementRouter} />
        <>
          <Layout>
            <Spin spinning={isLoading}>
              <Content style={{ minHeight: '60vh' }}>
                {isSuccess && data ? (
                  <>
                    <BusinessPartnerManagementRouter
                      moduleCtx={{ rootUrl: url }}
                      businessPartnerCtx={data}
                    />
                  </>
                ) : (
                  !isLoading && (
                    <Result
                      status="warning"
                      title={intlMessage({
                        id: 'businessPartner.dataLoadingWarning',
                      })}
                    />
                  )
                )}
              </Content>
            </Spin>
          </Layout>
        </>
      </Switch>
    </DashboardContainerLayout>
  );
};
